import {
  UpdateUserSettingsMutationResponse,
  updateUserSettingsMutation,
} from "@framework/cyclone/graphql/mutation";
import { makeRequest } from "@framework/cyclone/request";
import { UserSettingsInput } from "@framework/cyclone/types";

export const updateUserSettings = async (
  communityID: string,
  userID: string,
  settings: UserSettingsInput,
  serverURL: string,
  token?: string | null,
) => {
  const communityIDStr = `${communityID}`;
  if (!token) {
    return;
  }

  const url = new URL("/api", serverURL);
  const response = await makeRequest<UpdateUserSettingsMutationResponse>(
    url.toString(),
    updateUserSettingsMutation as string,
    {
      communityID: communityIDStr,
      userID,
      settings,
    },
    token,
  );

  if (response.errors || !response.data) {
    return;
  }

  return response.data.updateUserSettings;
};
